import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { WhatsAppCta } from './WhatsAppCta';
import { WHATSAPP_DISPLAY, whatsappLink } from '../utils/whatsapp';
export function FinalCta() {
  return <section className="bg-blood px-5 py-16 lg:px-8 lg:py-20" id="consulta" data-id="element-52" data-mp="19fgv6200386e">
      <div className="mx-auto max-w-3xl text-center" data-id="element-53" data-mp="15ddgl4i1bngw">
        <h2 className="font-display text-3xl uppercase tracking-[0.08em] text-white sm:text-4xl" data-id="element-54" data-mp="15ckg2l9o5u77">
          Salud, amor, suerte y éxito
        </h2>
        <p className="mt-5 text-lg text-white/85" data-id="element-55" data-mp="1ee1zacidic04">
          Escribime ahora mismo por WhatsApp y contame tu caso. Tu consulta es
          privada y confidencial.
        </p>

        <div className="mt-9 flex flex-col items-center gap-5" data-id="element-56" data-mp="1t50zaz557s83">
          <WhatsAppCta size="lg" label="¡¡Consulta ahora!!" data-id="element-57" data-mp="1o56bj4gnzir9" />
          <a href={whatsappLink()} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-xl font-semibold text-white underline decoration-white/40 decoration-2 underline-offset-4 transition-colors duration-150 ease-out hover:text-gold-soft" data-id="element-58" data-mp="223d01tzq46e9">
            <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-59" data-mp="s5gwe3j6iplv" />
            {WHATSAPP_DISPLAY}
          </a>
        </div>
      </div>
    </section>;
}